// Contactformulier: knop Afdrukken bij het herroepingsformulier en focus op de bevestiging na verzenden.

class PrintButton extends HTMLElement {
  connectedCallback() {
    this.querySelector('button')?.addEventListener('click', () => window.print());
  }
}

if (!customElements.get('print-button')) customElements.define('print-button', PrintButton);

document.querySelector('[data-contact-success]')?.focus();
